/**
 * Customer engagement settings API client (BFF: `/api/v1/store/settings/engagement`).
 */
import { apiClient } from '@/shared/api';
import type { EngagementSettings, UpdateEngagementSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/engagement';

export const getEngagementSettings = async (): Promise<EngagementSettings> =>
  (await apiClient.get<EngagementSettings>(BASE)).data;

export const updateEngagementSettings = async (
  body: UpdateEngagementSettingsRequest,
): Promise<EngagementSettings> => (await apiClient.put<EngagementSettings>(BASE, body)).data;
